import { Field, Formik, Form } from "formik";
import React, { Component } from "react";
import {
  Button,
  Col,
  Container,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { UserBank, UserBankStatus, AccountType } from "../../../generated";
import * as IBAN from "iban";

export interface State {
  loading: boolean;
}

export interface Props {
  onClosed?: () => void;
  onSubmit?: (bank: UserBank) => void;
  close?: () => void;
  bank: UserBank;
  isAdminMode: boolean;
}

const CustomSelectComponent = (props: any) => (
  <select className="form-control" {...props} />
);

export class EditUserBankModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  render() {
    if (!this.props.bank) {
      return <></>;
    }

    return (
      <Modal isOpen={!!this.props.bank} onClosed={this.props.onClosed}>
        <Formik initialValues={this.props.bank} onSubmit={this.props.onSubmit}>
          {({ values, errors, touched }) => (
            <Form>
              <ModalHeader>
                Editing{" "}
                {this.props.bank.displayName ?? this.props.bank.legalName}
              </ModalHeader>
              <ModalBody>
                <Container>
                  <Row>
                    <Col xs={12}>
                      <FormGroup>
                        <Label>Type</Label>
                        <Field name="accountType" as={CustomSelectComponent}>
                          <option value="" />
                          {Object.values(AccountType).map((at) => (
                            <option key={at} value={at}>
                              {at}
                            </option>
                          ))}
                        </Field>
                      </FormGroup>
                      <FormGroup>
                        <Label>Status</Label>
                        <Field name="status" as={CustomSelectComponent}>
                          <option value="" />
                          {Object.values(UserBankStatus).map((ubs) => (
                            <option key={ubs} value={ubs}>
                              {ubs}
                            </option>
                          ))}
                        </Field>
                      </FormGroup>
                    </Col>
                  </Row>
                  {values.status === UserBankStatus.AVAILABLE && (
                    <Row>
                      <Col xs={12}>
                        <FormGroup>
                          <Label htmlFor={`iban`}>IBAN</Label>
                          <Input
                            name="iban"
                            type="text"
                            tag={Field}
                            placeholder=""
                            validate={(value: string) => {
                              if (
                                !this.props.isAdminMode &&
                                value === "" &&
                                values.bban === ""
                              ) {
                                return "Please insert either IBAN or BBAN number to add your account";
                              } else if (value === "") {
                                return undefined;
                              }
                              return IBAN.isValid(value)
                                ? undefined
                                : "IBAN is invalid";
                            }}
                            valid={!errors.iban && touched.iban}
                            invalid={errors.iban && touched.iban}
                          />
                          {errors.iban && touched.iban && (
                            <FormFeedback>{errors.iban}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                  {values.status === UserBankStatus.AVAILABLE && (
                    <Row>
                      <Col xs={12}>
                        <FormGroup>
                          <Label htmlFor={`bban`}>BBAN</Label>
                          <Input
                            name="bban"
                            type="text"
                            tag={Field}
                            placeholder=""
                            valid={!errors.bban && touched.bban}
                            invalid={errors.bban && touched.bban}
                          />
                          {errors.bban && touched.bban && (
                            <FormFeedback>{errors.bban}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                </Container>
              </ModalBody>
              <ModalFooter>
                <Button
                  type={"button"}
                  color="secondary"
                  onClick={this.props.close}
                >
                  Close
                </Button>
                <Button type={"submit"} color="success">
                  Save
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    );
  }
}
